import { render } from "./jbh_CGSB.vue?vue&type=template&id=3429d7fb"
import script from "./jbh_CGSB.vue?vue&type=script&setup=true&lang=js"
export * from "./jbh_CGSB.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/jbh/jbh_CGSB.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3429d7fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3429d7fb', __exports__)) {
    console.log('reload')
    api.reload('3429d7fb', __exports__)
  }
  
  module.hot.accept("./jbh_CGSB.vue?vue&type=template&id=3429d7fb", () => {
    console.log('re-render')
    api.rerender('3429d7fb', render)
  })

}


export default __exports__